var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-container', [_vm.$options.components['advertisement-loading'] ? [_vm.isLoading ? _c('advertisement-loading') : _vm._e()] : _vm._e(), !_vm.isLoading ? _c('b-row', [_c('b-col', {
    staticClass: "my-4"
  }, [_c('div', {
    staticClass: "main-banner"
  }, [_c('img', {
    attrs: {
      "src": _vm.sampleCollectionBannerImage.icon && _vm.sampleCollectionBannerImage.icon.fileUrl || '',
      "alt": "Sample Collection Market Banner"
    }
  })]), _c('b', {}, [_vm._v("Category")]), _vm.list && _vm.list.length ? _c('sections-slider', {
    attrs: {
      "list": _vm.list,
      "subTitle": "Health Care",
      "hasInnerBackground": true,
      "hasButton": false,
      "withSlider": true
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref) {
        var listItem = _ref.listItem;
        return [_c('div', {
          staticClass: "item-box"
        }, [_c('items-item', {
          attrs: {
            "itemLogo": true,
            "product": listItem,
            "incrementDecrementKey": false,
            "marketRoute": {
              name: listItem.name == 'Health Care' ? `health-care` : `healthcare-market-view`,
              params: {
                market: listItem.name,
                id: listItem._id,
                items: listItem.externalAttributes
              }
            }
          }
        })], 1)];
      }
    }], null, false, 3063903631)
  }) : _vm._e(), _c('sections-slider', {
    staticClass: "suggested-slider",
    attrs: {
      "list": _vm.itemSuggestions,
      "subTitle": "Top Booked Test",
      "showTitle": true,
      "hasBackground": false,
      "hasButton": true,
      "withSlider": true,
      "viewMorePage": {
        name: `health-care-listing`,
        params: {
          items: `Most Popular`
        }
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref2) {
        var listItem = _ref2.listItem;
        return [_c('div', {
          staticClass: "item-box ml-2 mr- 2"
        }, [_c('items-item', {
          staticClass: "suggester-div",
          attrs: {
            "itemNoBg": true,
            "product": listItem,
            "incrementDecrementKey": true
          }
        })], 1)];
      }
    }], null, false, 287040945)
  }), _c('sections-slider', {
    staticClass: "suggested-slider",
    attrs: {
      "list": _vm.newArrivals,
      "subTitle": "Test Packages",
      "showTitle": true,
      "hasBackground": false,
      "hasButton": true,
      "withSlider": true,
      "viewMorePage": {
        name: `health-care-listing`,
        params: {
          items: `Daily Essentials`
        }
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref3) {
        var listItem = _ref3.listItem;
        return [_c('div', {
          staticClass: "item-box ml-2 mr- 2"
        }, [_c('items-item', {
          staticClass: "suggester-div",
          attrs: {
            "itemNoBg": true,
            "product": listItem,
            "incrementDecrementKey": true
          }
        })], 1)];
      }
    }], null, false, 287040945)
  })], 1)], 1) : _vm._e()], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }